module.exports = "../dist/img/upper-banner-41.442e.jpg";